import styled from 'styled-components'

const SearchFieldStyled = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  .ant-input-affix-wrapper {
    border-radius: 3rem;
    padding: 5px 7px;
    border-color: transparent;
    background: ${({ theme }) => theme.color.backgroundBack};

    &:hover,
    &.ant-input-affix-wrapper-focused {
      border-color: ${({ theme }) => theme.color.main};
    }

    input {
      background: transparent;
    }
  }

  .anticon {
    font-size: 1.5rem;
    color: ${({ theme }) => theme.color.mainText};
  }

  .ant-input-clear-icon {
    color: ${({ theme }) => theme.color.softText};
    font-size: 1.4rem;
  }
`
export default SearchFieldStyled
